import React, { useState, useEffect } from "react";

import { FaCheck, FaDotCircle } from "react-icons/fa";

import { Calender } from "../../components/Calender/Calender";
import apiClient from "../../api/apiClient";

import moment from "moment";
import { toast } from "react-toastify";

function formatDate(date, format = "YYYY-MM-DD") {
  return moment(date).format(format);
}

export default  () => {
  const [keyss, setKeyss] = useState([]);

  
  const[ event,setevents]=useState([])
 
  
  const [vehiclesid,setvehiclesid]=useState()
  
 

 

  
  const fetchevent = async () => {
    const res = await apiClient.get("/schedule/events/");
    
    if (res.ok) {
      setevents(res.data);
    }}


  const fetchRequest = async () => {
    const res = await apiClient.get("/schedule/event-types/");
    if (res.ok) {
      setKeyss(res.data);
    }
  };
  useEffect(() => {
    fetchRequest();

   
  }, []);
  useEffect(() => {

    fetchevent()
   
  }, []);
  
 const onEventSubmit = async (data) => {
    const formdata={...data}
     formdata.date=formatDate(formdata.date)

    const result = await apiClient.post("/schedule/events/", formdata);
    console.log(formdata,"shshsh")
    fetchevent()
    
    if(result.ok){
      toast.success("add event")
    }else(toast.error("error "))
    
    // let result;
    // if(!result.ok)   
  };
 
  function eventIcon(icon) {
    switch (icon) {
      case "Photoshoot":
        return (
          <img
            width="100%"
            src={require("../../assets/img/camera-icon.png")}
            alt=""
          />
        );
        break;
      case "campaigns start":
        return <FaDotCircle color="#00D030" />;
        break;
      case "campaigns End":
        return <FaDotCircle color="#F20000" />;
        break;
      case "Special Event":
        return (
          <i
            className="bi bi-balloon-heart-fill"
            style={{
              color: "black",
              fontSize: "22px",
              display: "flex",
              alignItems: "center",
            }}
          ></i>
        );
        break;
      case "Swarm":
        return (
          <img width="100%" src={require("../../assets/img/bee.png")} alt="" />
        );
        break;
      case "Repair":
        return (
          <img
            width="100%"
            src={require("../../assets/img/retargeting.png")}
            alt=""
          />
        );
        break;
      case "Removal":
        return (
          <img
            width="100%"
            src={require("../../assets/img/schedule-x-icon.PNG")}
            alt=""
          />
        );
        break;
      case "Install":
        return (
          <img
            width="100%"
            src={require("../../assets/img/schedule-job-icon.png")}
            alt=""
          />
        );
        break;
      default:
        break;
    }
  }
  const [submitData, setSubmitData] = useState(
  


  );
  const [data, setData] = useState();
  const [vehicles, setVehicles] = useState([]);

  const handleChange = (key, value) => {
    setSubmitData({
      ...submitData,
      [key]: value,

    });
  };
  const fetch = async () => {
    const response = await apiClient.get("/vehicles/vehicles/");
    if (response.ok) {
      const data = response.data;
      console.log(data,"lpplplp")
      setVehicles(data);
      //  setvehiclesid({vehicle_id:data[0].id})
      

    }
  };

  useEffect(() => {
    fetch();
  }, []);

  // console.log(vehiclesid,"id")
  const handleEventsChange = async (events) => {
    const eventObjects = events.map((event) => ({
      color: event.color,
      date_time: event.date,
      title: event.title,
    }));
    setSubmitData({
      ...submitData,
      events: eventObjects,
    });
  };
  const currentDate = new Date();
  const options = {
    weekday: "long",
    month: "long",
    day: "numeric",
    suffix: "long",
  };
  const formattedDate = currentDate.toLocaleDateString("en-US", options);

  const displayDate = data?.date || formattedDate;

  function handleDateClick(date, events) {
    console.log({ date, events });
    setData({ date, events });
  }
  const handleSubmit = (e) => {
    e.preventDefault();
   
      onEventSubmit()
 
    
  };

 
          
  return (
    <div>
      <form >
        <div className="">
          <div className="dropdown mb-2 ">
            <button
              className="  btn btn_bg shadow-none dropdown-toggle w-25"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Vehicle
            </button>
            <ul
              className="dropdown-menu "
              style={{ color: "#005E9D" }}
              aria-labelledby="dropdownMenuButton1"
            >
              {
              
              vehicles.length>0? vehicles.map((vehicle, index) => {

        
                return (
                  <div  style={{cursor:"pointer"}} className="" key={index}  >
 <li
                    
                    className="px-2 py-2 "
                    style={{ display: "flex", alignItems: "center" }}
                    // onClick={() => handleChange("vehicle_type", "Isuzu")}
                    onClick={()=> setvehiclesid({vehicle_id:vehicle.id})}
                  >
                    <div style={{ width: "4rem" }}>
                      <img
                        style={{ width: "100%" }}
                        src={vehicle.frontside_image}
                        alt=""
                      />
                    </div>
                    <a
                      className="dropdown-item t fw-bold"
                      style={{ color: "#005E9D" }}
                    >
                      {vehicle.vehicle_model}
                    </a>
               {   console.log(vehicles,'dendkendenjndjen')}
                  </li>
                  </div>
                 
                  
                );
              }):"Add vehicles frist"
              
              
              }


           
            </ul>
          </div>
        </div>
        <div className="zoom">

       
        <Calender   fetchevent={fetchevent} save={event} onEventSubmit={onEventSubmit} keyss={keyss} handleDateClick={handleDateClick}
        
        eventRecords={event}
  vehiclesid={vehiclesid} />

</div>
        <div className="row mt-2">
          <div className="col-md-8">
            <div className="border h-100 me-2 p-2 rounded-3">
              <h5 className="text_color  ">{displayDate}</h5>
              <hr className="hr_design mt-0" />
              {!(event == 0) ? (
                <>


                  {event?.map((event) => {
                


                    let title = "";
                    if (event.title === 1) {
                      title = "Install"
                    } else if (event.event_type === 2) {
                      title ="Removal"
                    }
                    else if (event.event_type === 3) {
                      title = "Repair"
                    }
                    else if (event.event_type === 4) {
                      title = "Photoshoot"
                    }
                    else if (event.event_type === 5) {
                      title = "Swarm"
                    }
                    else if (event.event_type === 6) {
                      title = "Swarm"
                    }
                    
                    return (
                      <div className="d-flex gap-2 align-item-center flex-column flex-md-row">
                        <div style={{ width: "1rem", height:"1rem" }}>
                          <img src={event?.event_type?.icon_url} width={"100%"} height={"100%"} alt="" />
                        </div>

                        <span>
                          - {title} at {event.time} <br />- Address:{" "}
                          {event.address}
                        </span>

                      </div>
                    );
                  })}
                </>
              ) : (
                "No Event"
              )}
              
             
            </div>
          </div>
          <div className="col-md-4 border p-2 rounded-3">
            <div className="d-flex gap-3 align-item-center px-2">
              <div>
                <h5 className="text_color">Key</h5>
                <hr className="hr_design_2 mt-0" />
              </div>
              <div className="mt-3 ">
                {keyss.map((event, index) => {
                  return (
                    <p key={index} className=" text_color d-flex align-items-center gap-1">
                      <div style={{ width: "1rem" }}>
                        <img width="100%" src={event.icon_url} alt="" />
                      </div>
                      {event.request_type}
                    </p>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col text-center mt-5 save-main">
            <button  onClick={()=>fetch()} className="btn_bgnone btn blue-clr">
              <span className="pe-2">Save Changes</span>
              <FaCheck />
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
